import jsonToFormData from "./jsonToFormData";

const form = {
    parse: jsonToFormData
}

export default form;
